// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"262":"7cccf76e","739":"bedef7a3"}[chunkId] + ".chunk.js";
};